import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";

import "./Main.scss";
import "./Similar.scss";
import Main from "./Main";
import Spinner from "./Spinner";
import { HOST, IMG_URL } from "../constants";

const Similar = (props) => {
  const { state } = useLocation();
  const navigate = useNavigate();
  //   console.log("state: ", state);

  const { poster_path, title, vote_average, overview, id } = state;
  const [pageNumber, setPageNumber] = useState(1);
  const [isHiddenNavigationPage, setIsHiddenNavigationPage] = useState(true);
  const [isMainHidden, setIsMainHidden] = useState(true);

  const getColor = (vote) => {
    if (vote >= 8) {
      return "green";
    } else if (vote >= 5) {
      return "orange";
    } else {
      return "red";
    }
  };

  return (
    <div className="Similar">
      <button
        onClick={() => {
          navigate("/");
        }}
        className="homebtn topLeft"
      >
        Home
      </button>
      <div className="mainMovieSection">
        <div className="movie">
          <div class="movie_img">
            <img
              src={`${
                poster_path
                  ? IMG_URL + poster_path
                  : "http://via.placeholder.com/1080x1580"
              }`}
              alt={title}
            />
            <div className="overview">
              <h3>Overview</h3>
              {overview}
            </div>
          </div>

          <div className="movie-info">
            <h3>{title}</h3>
            <span className={getColor(vote_average)}>{vote_average}</span>
          </div>
        </div>
      </div>
      <div className="movieHeadingSection">
        <div className="movieHeadingBox">
          <h3 className="movieHeading">
            {`Movies Similar to `}{" "}
            <span className="highlightHeading">{title}</span>{" "}
          </h3>
        </div>
      </div>
      <div className="spinnerSection">
        <Spinner
          visible={isMainHidden}
          text={"Loading Movies"}
          type={"TailSpin"}
        />
      </div>
      <Main
        isMainHidden={isMainHidden}
        setIsMainHidden={setIsMainHidden}
        page={pageNumber}
        setPageNumber={setPageNumber}
        setIsHiddenNavigationPage={setIsHiddenNavigationPage}
        isSimilar={true}
        selectedMovieID={id}
        selectedMovieIDTitle={title}
      />
    </div>
  );
};

export default Similar;
